import classNames from 'classnames'
import { FC } from 'react'

import styles from './ConditionBall.module.scss'

type Props = {
  done?: boolean
  className?: string
}

export const ConditionBall: FC<Props> = ({ done = false, className }) => {
  return (
    <div
      className={classNames(styles.ball, className, { [styles.locked]: !done })}
    >
      <div className={styles.outer} />
      <div className={styles.inner} />
      {done && (
        <svg
          className={styles.check}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path
            d="M2 6.2L4.8 9L10 3.4"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  )
}
